'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var request = require('request');
var Masonry = require('masonry-layout');

window.dismissNotification = function (elem) {
  $(elem).closest('.notification').remove();
};

function onMasonryLayout(laidOutItems) {

  var cols = {},
      colNames = [],
      left,
      top,
      col,
      elem;

  for (var i = 0; i < laidOutItems.length; i++) {
    left = laidOutItems[i].position.x;
    if (!cols[left]) {
      cols[left] = [];
      colNames.push(left);
    }
    cols[left].push(laidOutItems[i]);
  }

  for (var i = 0; i < colNames.length; i++) {
    col = cols[colNames[i]];
    elem = col[col.length - 1].element;
    $(elem).removeClass('border-bottom');
  }
}

$(document).ready(function () {

  var keys = Object.keys(window);
  var keysString = "";
  for (var i = 0; i < keys.length; i++) {
    if (keys[i].indexOf('st') === 0) {
      keysString += keys[i] + "\n";
    }
  }
  // alert(keysString);
  if (window.navigator.standalone) {
    $('a').click(function (e) {
      e.preventDefault();
      document.location = $(this).attr('href');
    });
  }

  /*
  Pinning of reports. 
   */
  if ($('body.report-index').length) {

    $('table').on('click', '.pin-status', function () {
      var that = this;
      var id = $(that).closest('tr').data('id');
      var url = location.origin + '/ajax/reports/pin';
      var data = {
        _token: CSRF_TOKEN,
        report_id: id
      };

      request.post({ url: url, form: data }, function (err, response, body) {
        $(that).toggleClass('pinned');
      });
    });
  }

  /*
  Show and hide filters and pages that display them. 
  */
  $('.filter-btn').click(function () {
    $('.filter-wrapper').toggleClass('show');
  });

  /*
  Scroll to notes section when the little icon is pressed.
   */
  $('.note-count').click(function () {
    var offsetTop = $('.notes').offset().top - 120;
    $("body").animate({ scrollTop: offsetTop + "px" });
  });

  $('.init-masonry').each(function () {

    var msnry = new Masonry($(this)[0], {
      itemSelector: '.grid-item',
      gutter: '.gutter',
      transitionDuration: 0
    });
    msnry.on('layoutComplete', onMasonryLayout);
    msnry.layout();
  });
});

$('.ix-toggle-mobile-menu').click(function () {
  $('body').addClass('show-mobile-menu');
});

$('.ix-close-mobile-menu').click(function () {
  $('body').removeClass('show-mobile-menu');
});

$('.fg-text_variations').each(function () {

  $(this).find('.ix-add-variation').click(function () {
    var $parent = $(this).closest('.fg-text_variations');
    var slug = $parent.data('slug');
    var html = '<div class="variation"><input type="text" name="' + slug + '[]" value="" placeholder="Variation..."><div class="remove ix-remove-variation"><i class="ri-minus-o"></i></div></div>';
    $parent.find('.form-group-input').append(html);
  });

  $(this).on('click', '.ix-remove-variation', function () {
    $(this).parent().remove();
  });
});

if ($('body').hasClass('data-budget')) {
  $('[data-toggle="tooltip"]').tooltip();
}

if ($('body').hasClass('directory-editmodelcontacts')) {

  $('.ix-add-contact').click(function () {
    var html = $('.new-contact-template').html();
    var newCount = $('.edit-contacts-list .contact-new').length || 0;
    html = html.replace(/ididid/g, newCount);
    $('.edit-contacts-list').append(html);
  });

  $('.edit-contacts-list').on('click', '.ix-remove', function () {
    $(this).closest('.contact-new').remove();
  });
}

/*
Matches polyfill
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
    while (--i >= 0 && matches.item(i) !== this) {}
    return i > -1;
  };
}

exports.default = 'global';


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/global.js
// module id = 526
// module chunks = 0